import Layout from "../../components/Layout";
import Head from "next/head";
import { useEffect } from "react";
import ReactGA from "react-ga";
import Login from "../../components/login/login";
import Signup from "../../components/signup/signup";
import { withoutAuth } from "../../components/hoc/auth";
import { useRouter } from "next/router";

const Signin = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const router = useRouter();
    
    const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;

  return (
    <Layout showSecFooter>
      <Head>
      <link rel="canonical" href={canonicalUrl} />
        <title>Sign Up or Log In | Kilimanjaro Restaurants </title>

        <meta
          name="description"
          content="Sign up or log in to your Kilimanjaro account to access your saved details, place orders faster, and enjoy exclusive offers and updates."
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
        />
      </Head>
      <h1 className="visually-hidden">Kilimanjaro registration</h1>
      <section className="signup">
        <div className="container">
          <div className="row">
            <Login />
            <div className="col-md-2 d-md-block d-none">
              <p className="or-text">Or</p>
            </div>
            <Signup />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default withoutAuth(Signin);
